import { render } from "./UsersDropdown.vue?vue&type=template&id=1ffb56a6&scoped=true"
import script from "./UsersDropdown.vue?vue&type=script&lang=js"
export * from "./UsersDropdown.vue?vue&type=script&lang=js"

import "./UsersDropdown.vue?vue&type=style&index=0&id=1ffb56a6&scoped=true&lang=css"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ffb56a6"]])

export default __exports__